export const firebaseConfig = {
  apiKey: "AIzaSyADQn_5qMf_DbCBvlt1yEDTIw2pcRcHm8Y",
  authDomain: "financial-fe.firebaseapp.com",
  projectId: "financial-fe",
  storageBucket: "financial-fe.appspot.com",
  messagingSenderId: "753910980411",
  appId: "1:753910980411:web:23ac00a60eb0bf744fa11e",
  measurementId: "G-Q0ZK7HHDV7",
};
